/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { formatGBP } from "../../leak detection/helper/helperFunctions";
import { InputNumber } from "primereact/inputnumber";

const AddJobNumbers = ({
  showAddJobNumber,
  rowData,
  title,
  isEditMode,
  invoiceParam,
  setFormValues,
  currency,
  allProjects,
  newAllProjects,
  isResetForm,
  setIsResetForm,
  onClose,
  tempJobEntries,
  setTempJobEntries,
  validationErrors,
  setValidationErrors,
  handleJobNumberChange,
  handleAmountChange,
  newTempJobNumbers,
  setNewTempJobNumbers,
  setShowAddJobNumber,
}: any) => {
  const [selectedCurrency, setSelectedCurrency] = useState<any>({
    currencyID: 2,
    currencyName: "Pound sterling",
    currencySymbol: "£",
    createdDate: "2024-09-23T11:00:26.000Z",
    isActive: true,
  });

  // Initialize tempJobEntries when the dialog is opened
  useEffect(() => {
    // alert(showAddJobNumber)
    if (showAddJobNumber === true) {
      setNewTempJobNumbers(tempJobEntries);
    }

    if (showAddJobNumber) {
      if (rowData && rowData.jobNoMapping) {
        // Populate tempJobEntries from rowData.jobNoMapping
        const mappedEntries = rowData.jobNoMapping.map((mapping: any) => ({
          jobNumber: newAllProjects.find(
            (project: any) => project.projectID === mapping.jobNumber
          )?.projectID,
          amount: mapping.amount.toString(),
        }));
        if (mappedEntries.length > 0 && title === "View Job No") {
          setTempJobEntries(mappedEntries);
          setNewTempJobNumbers(mappedEntries);
        } else if (
          newTempJobNumbers.length === 0 ||
          (newTempJobNumbers.length === 1 &&
            newTempJobNumbers[0].jobNumber === "")
        ) {
          setTempJobEntries(mappedEntries);
          setNewTempJobNumbers(mappedEntries);
        }
        // else {
        //   setTempJobEntries([{ jobNumber: "", amount: "" }]);
        // }
        // setTempJobEntries(
        //   mappedEntries.length > 0
        //     ? mappedEntries
        //     : [{ jobNumber: "", amount: "" }]
        // );
        if (rowData.selectedCurrency) {
          // alert('dasda')
          setSelectedCurrency(rowData.selectedCurrency); // Reset selectedCurrency to initial state
        } else {
          setSelectedCurrency({
            currencyID: rowData.currencyID,
            currencyName: rowData.currencyName,
            currencySymbol: rowData.currencySymbol,
            createdDate: "2024-09-23T11:00:26.000Z",
            isActive: true,
          });
        }
      } else {
        // Use the latest jobEntries if rowData is not available
        setTempJobEntries((prevEntries: any) => {
          const uniqueEntries = tempJobEntries.filter(
            (newEntry: any) =>
              !prevEntries.some(
                (existingEntry: any) =>
                  existingEntry.jobNumber === newEntry.jobNumber
              )
          );
          return [...prevEntries, ...uniqueEntries];
        });
        setNewTempJobNumbers((prevEntries: any) => {
          const uniqueEntries = tempJobEntries.filter(
            (newEntry: any) =>
              !prevEntries.some(
                (existingEntry: any) =>
                  existingEntry.jobNumber === newEntry.jobNumber
              )
          );
          return [...prevEntries, ...uniqueEntries];
        });
      }
      setValidationErrors([]); // Reset validation errors
    }
  }, [showAddJobNumber]);

  useEffect(() => {
    if (isResetForm) {
      setTempJobEntries([{ jobNumber: "", amount: "" }]); // Reset tempJobEntries to initial state
      setValidationErrors([{ jobNumber: false, amount: false }]); // Reset validationErrors to initial state
      setSelectedCurrency({
        currencyID: 2,
        currencyName: "Pound sterling",
        currencySymbol: "£",
        createdDate: "2024-09-23T11:00:26.000Z",
        isActive: true,
      }); // Reset selectedCurrency if needed
    }
  }, [isResetForm]);

  const calculateTotal = () => {
    return tempJobEntries.reduce((total: any, entry: any) => {
      const amount = parseFloat(entry.amount) || 0;
      // Check if amount is a valid number before adding
      if (isNaN(amount)) {
        console.error("Invalid amount:", entry.amount);
        return total; // Skip invalid amounts
      }
      return total + amount;
    }, 0);
  };

  const jobNumberValueTemplate = (option: any) => {
    if (!option) {
      return "Select Job Number";
    }
    return (
      <div>
        {option.projectKey} - {option.name}
      </div>
    );
  };

  const handleAddEntry = () => {
    setTempJobEntries((prevEntries: any) => [
      ...prevEntries,
      { jobNumber: "", amount: "" },
    ]);
    setValidationErrors((prevErrors: any) => [
      ...prevErrors,
      { jobNumber: false, amount: false },
    ]);
  };

  // const handleJobNumberChange = (index: number, value: any) => {
  //   if (index < 0 || index >= tempJobEntries.length) {
  //     console.error("Invalid index for tempJobEntries:", index);
  //     return;
  //   }

  //   setTempJobEntries((prevEntries: any) => {
  //     const updatedEntries = [...prevEntries];
  //     updatedEntries[index] = {
  //       ...updatedEntries[index],
  //       jobNumber: value.projectID,
  //     };
  //     return updatedEntries;
  //   });

  //   setValidationErrors((prevErrors) => {
  //     const updatedErrors = [...prevErrors];
  //     updatedErrors[index] = {
  //       ...updatedErrors[index],
  //       jobNumber: !value.projectID,
  //     };
  //     return updatedErrors;
  //   });
  // };

  // const handleAmountChange = (index: number, value: string) => {
  //   // Validate index
  //   if (index < 0 || index >= tempJobEntries.length) {
  //     console.error("Invalid index for tempJobEntries:", index);
  //     return;
  //   }

  //   // Safely update tempJobEntries
  //   setTempJobEntries((prevEntries: any) => {
  //     const updatedEntries = [...prevEntries];
  //     updatedEntries[index] = {
  //       ...updatedEntries[index],
  //       amount: +value,
  //     };
  //     return updatedEntries;
  //   });

  //   // Safely update validationErrors
  //   setValidationErrors((prevErrors: any) => {
  //     const updatedErrors = [...prevErrors];
  //     updatedErrors[index] = {
  //       ...updatedErrors[index],
  //       amount: !value.trim(),
  //     };
  //     return updatedErrors;
  //   });
  // };

  const handleRemoveEntry = (index: number) => {
    setTempJobEntries((prevEntries: any) => {
      const updatedEntries = [...prevEntries];
      updatedEntries.splice(index, 1);
      return updatedEntries.length
        ? updatedEntries
        : [{ jobNumber: "", amount: "" }];
    });

    setValidationErrors((prevErrors: any) => {
      const updatedErrors = [...prevErrors];
      updatedErrors.splice(index, 1);
      return updatedErrors;
    });
  };

  const handleSave = () => {
    const errors = tempJobEntries.map((entry: any) => ({
      jobNumber: !entry.jobNumber || !allProjects.some((project: any) => project.projectID === entry.jobNumber),
      amount: !entry.amount,
    }));
    setValidationErrors(errors);

    const isValid = errors.every(
      (error: any) => !error.jobNumber && !error.amount
    );

    if (!isValid) {
      return;
    }

    const totalAmount =
      calculateTotal() % 1 === 0
        ? calculateTotal()
        : calculateTotal().toFixed(2);

    // Map tempJobEntries to jobNoMapping with projectID in jobNumber
    const jobNoMapping = tempJobEntries.map((entry: any) => {
      const project = allProjects.find(
        (project: any) => project.projectID === entry.jobNumber
      );
      return {
        jobNumber: project?.projectID || null, // Use projectID instead of projectKey
        amount: parseFloat(entry.amount),
      };
    });

    setFormValues((prevValues: any) => ({
      ...prevValues,
      jobNoMapping: jobNoMapping, // Add jobNoMapping to formValues
      selectedCurrency: selectedCurrency,
      totalAmount: totalAmount,
    }));
    setNewTempJobNumbers(jobNoMapping); // Update newTempJobNumbers with the latest jobNoMapping
    setIsResetForm(false); // Reset the form state
    setShowAddJobNumber(false); // Close the dialog
  };

  const handleCancel = () => {
    setTempJobEntries(newTempJobNumbers);
    onClose(); // Simply close the dialog without saving changes
  };

  // Custom footer for the dialog
  const renderFooter = () => {
    return (
      <>
        {isEditMode === true || !invoiceParam ? (
          <div className="tw-flex tw-justify-end tw-gap-3 tw-pt-4 tw-border-t tw-border-gray-200">
            <Button
              onClick={handleCancel}
              className="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-md tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              className="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-bg-primary tw-border tw-border-transparent tw-rounded-md tw-shadow-sm hover:tw-bg-[#38bdf8] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2"
            >
              Save
            </Button>
          </div>
        ) : null}
      </>
    );
  };

  const jobNumberOptionsTemplate = (option: any) => {
    return (
      <div>
        <span className="tw-font-medium">{option.projectKey}</span> -{" "}
        <span>{option.name}</span>
      </div>
    );
  };

  return (
    <Dialog
      header={title}
      visible={showAddJobNumber}
      style={{ width: "90%", maxWidth: "650px" }}
      onHide={handleCancel}
      footer={renderFooter()}
      className="tw-shadow-lg"
    >
      <div className="tw-flex tw-flex-col tw-gap-5 tw-p-2">
        {/* Currency Selection Section */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          {!(
            tempJobEntries.length === 1 &&
            tempJobEntries[0].jobNumber === "" &&
            title === "View Job No"
          ) && (
            <div className="tw-flex tw-justify-end tw-items-center">
              <h3 className="tw-text-gray-700 tw-font-medium tw-mr-4">
                {title === "View Job No" ? "Currency" : "Select Currency"}
              </h3>
              <div>
                {isEditMode === true || !invoiceParam ? (
                  <Dropdown
                    className="tw-h-10 tw-border tw-border-gray-300 tw-rounded-md tw-w-36 tw-shadow-sm focus:tw-ring-blue-500 focus:tw-border-blue-500 filter-dropdown"
                    value={
                      (currency &&
                        currency.find(
                          (item: any) =>
                            item.currencyID === selectedCurrency?.currencyID
                        )) ??
                      ""
                    }
                    options={currency}
                    disabled={!(isEditMode === true || !invoiceParam)}
                    onChange={(e) => {
                      setSelectedCurrency(e.value);
                    }}
                    optionLabel="currencySymbol"
                    placeholder="Currency"
                    onClick={(e) => e.stopPropagation()}
                  />
                ) : (
                  <InputText
                    type="text"
                    value={
                      (currency &&
                        currency.find(
                          (item: any) =>
                            item.currencyID === selectedCurrency?.currencyID
                        )?.currencySymbol) ??
                      ""
                    }
                    // onChange={(e) => handleAmountChange(index, e.target.value)}
                    placeholder="Currency"
                    readOnly
                    className="tw-h-10 tw-border tw-border-gray-300 tw-rounded-md tw-w-36 tw-pl-4 tw-shadow-sm focus:tw-ring-blue-500 focus:tw-border-blue-500"
                  />
                )}
              </div>
            </div>
          )}
        </div>

        {/* Divider */}
        <div className="tw-border-t tw-border-gray-200"></div>

        {/* Job Entries Section */}
        <div className="tw-flex tw-flex-col tw-gap-3">
          {/* <h3 className="tw-text-gray-700 tw-font-medium">Job Details</h3> */}

          {/* Column Headers */}
          <div>
            {tempJobEntries.length === 1 &&
            tempJobEntries[0].jobNumber === "" &&
            title === "View Job No" ? (
              <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
                <span>No job number found.</span>
              </div>
            ) : (
              <div className="tw-grid tw-grid-cols-12 tw-gap-3 tw-mb-1 tw-text-sm tw-text-gray-500 tw-font-medium">
                <div className="tw-col-span-7">Job Number</div>
                <div className="tw-col-span-4">Amount</div>
                <div className="tw-col-span-1"></div>
              </div>
            )}
          </div>

          {!(
            tempJobEntries.length === 1 &&
            tempJobEntries[0].jobNumber === "" &&
            title === "View Job No"
          ) &&
            tempJobEntries.map((entry: any, index: any) => (
              <div
                key={index}
                className="tw-grid tw-grid-cols-12 tw-gap-3 tw-items-center"
              >
                <div className="tw-col-span-7">
                  {isEditMode === true || !invoiceParam ? (
                    <Dropdown
                      className={`tw-w-full tw-h-10 tw-border tw-rounded-md tw-shadow-sm filter-dropdown ${
                        validationErrors[index]?.jobNumber
                          ? "tw-border-red-500"
                          : "tw-border-gray-300"
                      }`}
                      value={
                        isResetForm
                          ? null
                          : allProjects.find(
                              (project: any) =>
                                project.projectID === entry.jobNumber
                            )
                      }
                      options={allProjects.filter(
                        (project: any) =>
                          !tempJobEntries.some(
                            (entry: any, entryIndex: number) =>
                              entryIndex !== index &&
                              entry.jobNumber === project.projectID
                          )
                      )}
                      itemTemplate={jobNumberOptionsTemplate}
                      valueTemplate={jobNumberValueTemplate}
                      onChange={(e) => handleJobNumberChange(index, e.value)}
                      placeholder="Select Job Number"
                      optionLabel="name"
                      onClick={(e) => e.stopPropagation()}
                      filterBy="projectKey,name"
                      filterMatchMode="contains"
                      filter
                    />
                  ) : (
                    <InputText
                      className={`tw-w-full tw-h-10 tw-pl-8 tw-pr-3 tw-py-2 tw-border tw-rounded-md focus:tw-outline-none ${
                        validationErrors[index]?.jobNumber
                          ? "tw-border-red-500"
                          : "tw-border-gray-300"
                      }`}
                      value={
                        isResetForm
                          ? null
                          : newAllProjects.find(
                              (project: any) =>
                                project.projectID === entry.jobNumber
                            )
                          ? `${
                              newAllProjects.find(
                                (project: any) =>
                                  project.projectID === entry.jobNumber
                              )?.projectKey
                            } - ${
                              newAllProjects.find(
                                (project: any) =>
                                  project.projectID === entry.jobNumber
                              )?.name
                            }`
                          : ""
                      }
                      readOnly
                      placeholder="Job Number"
                      onClick={(e) => e.stopPropagation()}
                      tooltip={
                        `${
                          isResetForm
                          ? null
                          : newAllProjects?.find(
                              (project: any) =>
                                project?.projectID === entry?.jobNumber
                            )
                          ? `${
                              newAllProjects?.find(
                                (project: any) =>
                                  project?.projectID === entry?.jobNumber
                              )?.projectKey
                            } - ${
                              newAllProjects?.find(
                                (project: any) =>
                                  project?.projectID === entry?.jobNumber
                              )?.name
                            }`
                          : ""}`
                      }
                      tooltipOptions={{
                        position: "bottom",
                        // showDelay: 500,
                      }}
                    />
                  )}
                </div>
                <div className="tw-col-span-4">
                  <div className="tw-relative tw-rounded-md tw-shadow-sm">
                    <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
                      <span className="tw-text-gray-500">
                        {selectedCurrency?.currencySymbol}
                      </span>
                    </div>
                    <InputNumber
                      value={isResetForm ? null : title === "View Job No" ? formatGBP(entry.amount, 'showMultiJobPopup') : entry.amount}
                       onChange={(e) => {
                      // const value = e.target.value;
                      // const regex = /^(?!0\d)\d*(\.\d{0,2})?$/; // Allow only numbers with up to 2 decimal places and prevent leading zeros
                      // if (/^(?!0$)\d*(\.\d{0,2})?$/.test(value)) {
                        // }
                          handleAmountChange(index, e.value);
                      }}
                      useGrouping={true}
                      placeholder="0.00"
                      locale="en-GB"
                      minFractionDigits={2}
                      readOnly={!(isEditMode === true || !invoiceParam)}
                      className={`tw-w-full tw-h-10 tw-pl-8 tw-pr-3 tw-py-2 tw-border tw-rounded-md focus:tw-outline-none ${
                        validationErrors[index]?.amount
                          ? "tw-border-red-500"
                          : "tw-border-gray-300"
                      }`}
                      onKeyDown={(evt) => {
                        if (
                          evt.key === "e" ||
                          evt.key === "E" ||
                          evt.key === "+" ||
                          evt.key === "-" ||
                          evt.key === "ArrowUp" ||
                          evt.key === "ArrowDown"
                        ) {
                          evt.preventDefault();
                        }
                      }}
                      disabled={!entry.jobNumber} // Disable amount input if no job number is selected
                    />
                  </div>
                </div>
                {(isEditMode === true || !invoiceParam) && (
                  <div className="tw-col-span-1 tw-flex tw-justify-center">
                    <Button
                      onClick={() => handleRemoveEntry(index)}
                      className="tw-text-gray-400 hover:tw-text-red-500 focus:tw-outline-none focus:tw-shadow-none"
                      disabled={tempJobEntries.length === 1}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="tw-h-5 tw-w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </Button>
                  </div>
                )}
              </div>
            ))}

          {/* Add Button */}
          {(isEditMode === true || !invoiceParam || !invoiceParam) && (
            <Button
              onClick={handleAddEntry}
              className="tw-self-start tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-blue-600 tw-bg-blue-50 tw-border tw-border-blue-200 tw-rounded-md hover:tw-bg-blue-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 tw-mt-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="tw-h-4 tw-w-4"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
              Add
            </Button>
          )}
        </div>

        {/* Divider */}
        <div className="tw-border-t tw-border-gray-200 tw-mt-2"></div>

        {/* Total Amount */}
        {!(
          tempJobEntries.length === 1 &&
          tempJobEntries[0].jobNumber === "" &&
          title === "View Job No"
        ) && (
          <div className="tw-flex tw-justify-between tw-items-center tw-mt-2 tw-bg-gray-50 tw-p-3 tw-rounded-md">
            <span className="tw-text-gray-700 tw-font-medium">
              Total Amount:
            </span>
            <span className="tw-text-lg tw-font-bold tw-text-blue-600">
              {selectedCurrency?.currencySymbol} {formatGBP(calculateTotal().toFixed(2))}
            </span>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AddJobNumbers;
